exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: #fff;\r\n    flex-grow: 1;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/pages/page-searchable-list.component.css
// module id = 2274
// module chunks = 1